import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding pt-36 md:pt-40">
      <div className="container-custom grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-sm text-sky-700 border border-sky-200 rounded-full px-4 py-2 mb-6 bg-white">
            <Sparkles size={14} /> Premium International Dental Care
          </span>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6 text-[#0f172a]">
            {t('hero.title')}
          </h1>
          <p className="text-[#475569] text-lg leading-relaxed mb-8 max-w-2xl">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/contact" className="btn-primary">{t('hero.ctaPrimary')} <ArrowRight size={18} /></Link>
            <Link to="/gallery" className="btn-accent">{t('hero.ctaSecondary')}</Link>
          </div>
        </div>

        <div className="glass-card p-4 md:p-6">
          <img
            src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1200&q=80"
            alt="Crystal Dental luxury clinic"
            className="w-full h-[420px] object-cover rounded-2xl"
          />
          <div className="mt-4 grid grid-cols-2 gap-3 text-sm text-[#334155]">
            <div className="rounded-xl border border-[#e2e8f0] bg-[#f8fafc] p-3 inline-flex items-center gap-2"><ShieldCheck size={16} /> ISO Certified</div>
            <div className="rounded-xl border border-[#e2e8f0] bg-[#f8fafc] p-3 inline-flex items-center gap-2"><ShieldCheck size={16} /> 5000+ Patients</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
